/**
 * wrap function to have it run after ready promise resolves
 * @param func
 * @param ready promise to wait for
 * @returns wrapped function returns, promisified
 */
export function withReady(func, ready) {
    return ((...args) => {
        return ready.then(() => func(...args));
    });
}
